import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./SideBar.module.scss";
import IconLightTheme from "../Icons/IconLightTheme/IconLightTheme";
import IconDarkTheme from "../Icons/IconDarkTheme/IconDarkTheme";
import IconHideSideBar from "../Icons/IconHideSideBar";
import IconBoard from "../Icons/IconBoard";
import BoardTitle from "../BoardTitle/BoardTitle";
import rovatelMarkTeal from "../../assets/rovatel-mark-teal.png";
import rovatelMarkWhite from "../../assets/rovatel-mark-white.png";
import IconShowSideBar from "../Icons/IconShowSideBar";
import { BoardContext } from "../../store/board-context";
import { ModalContext } from "../../store/modal-context";
import { AuthContext } from "../../store/auth-context";
import { ThemeContext } from "../../store/theme-context";
import Slider from "./Slider/Slider";
const SideBar = () => {
  const navigate = useNavigate();

  const { selectBoard, boards, activeBoardIndex, sidebarOpen, setSidebarOpen } =
    useContext(BoardContext);
  const { openModal } = useContext(ModalContext);
  const { user, logout } = useContext(AuthContext);
  const { theme } = useContext(ThemeContext);
  const logoMark = theme === "_dark" ? rovatelMarkWhite : rovatelMarkTeal;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const sideBarClass = sidebarOpen
    ? classes.side_bar
    : `${classes.side_bar} ${classes.side_bar_hidden}`;

  function hideSideBar() {
    setSidebarOpen(false);
  }

  function showSideBar() {
    setSidebarOpen(true);
  }

  function addBoard() {
    openModal("addBoard");
  }

  return (
    <>
      {sidebarOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          className={classes.backdrop}
          onClick={hideSideBar}
        ></button>
      )}
      <section className={sideBarClass}>
        <div className={classes.logo}>
          <img src={logoMark} alt="Rovatel" />
          <span className={classes.logoText}>Rovatel</span>
        </div>
        <aside className={classes.side_bar_content}>
          <section className={classes.all_boards}>
            <span className={classes.all_boards_heading}>
              ALL BOARDS ({boards.length})
            </span>
            <ul className={classes.boards} style={{ marginTop: "2rem" }}>
              {boards.map((board, index) => (
                <BoardTitle
                  key={board.id}
                  title={board.title}
                  isSelected={index === activeBoardIndex}
                  onSelect={() => selectBoard(index)}
                />
              ))}
              <li
                className={`${classes.board} ${classes.create_new_board}`}
                onClick={addBoard}
              >
                <span className={classes.boardItem}>
                  <IconBoard fill="var(--color-primary)" />
                  <span className={classes.newBoard}>+Create New Board</span>
                </span>
              </li>
            </ul>
          </section>
          <section className={classes.controls}>
            <section className={`${classes.screen_mode}`}>
              <section className={classes.screen_mode_content}>
                <IconLightTheme />
                <Slider />
                <IconDarkTheme />
              </section>
            </section>
          </section>
          <span className={classes.sidebar_visibility}>
            <IconHideSideBar hideSideBar={hideSideBar} />
            <span className={classes.hide_sidebar}>hide sidebar</span>
          </span>
          {user && (
            <button type="button" className={classes.logout} onClick={handleLogout}>
              Log out ({user.email})
            </button>
          )}
        </aside>
      </section>

      <div className={classes.showSideBar}>
        <IconShowSideBar showSideBar={showSideBar} />
      </div>
    </>
  );
};

export default SideBar;
